import { z } from "zod/v4";

export function skipValidation<T>(): z.ZodType<T> {
  return z.custom<T>(() => true);
}
